import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8bbe3764"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner-cont" }
const _hoisted_2 = {
  key: 0,
  class: "dec-logo"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { key: 3 }

import { computed } from "vue";
import { useStore } from "vuex";
import LanguageSelect from "@/layout/header/LanguageSelect.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'BannerScreen',
  setup(__props) {

const store = useStore();
const isMobile = computed(() => !!store.state.isMobile as boolean);
const language = computed(() => store.state.appLanguage);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["banner", { mobileSize: _unref(isMobile) }])
  }, [
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(LanguageSelect, {
          key: 0,
          class: "bannerLang"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_unref(isMobile))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      (!_unref(isMobile))
        ? (_openBlock(), _createElementBlock("h1", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$t("home.title1")), 1),
            _hoisted_4,
            _createTextVNode(_toDisplayString(_ctx.$t("home.title2")) + " " + _toDisplayString(_ctx.$t("home.title3")), 1)
          ]))
        : (_openBlock(), _createElementBlock("h1", {
            key: 2,
            class: _normalizeClass('h1' + _unref(language))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.title1")), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.title2")), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.title3")), 1)
          ], 2)),
      (!_unref(isMobile))
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("home.document")), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        to: { path: '/privilege' },
        class: "shadowBtn"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("home.start_free")), 1)
        ]),
        _: 1
      })
    ])
  ], 2))
}
}

})